import React from "react";

const Loading = () => {
  return (
    <div
      className="text-center"
      style={{
        height: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img src="./images/Preloader.gif" alt=""/>
    </div>
  );
};

export default Loading;
